import { Alert, AlertIcon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useRoundSelection } from "./RoundSelectionContext";
import { stageLabel } from "./stageLabel";

export const TenderRoundNotice = () => {
  const { t } = useTranslation();
  const { selectedRound, tenderRound } = useRoundSelection();
  if (!selectedRound || selectedRound.id === tenderRound?.id) return null;

  return (
    <Alert status="info" rounded="md" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      <Text>
        {t("{{draft}} has not been sent to the suppliers yet. These are the tenders from the stage before it: {{stage}}.", {
          draft: stageLabel(t, selectedRound),
          stage: stageLabel(t, tenderRound),
        })}
      </Text>
    </Alert>
  );
};
